(() => {
  "use strict";

  // ==========================================================================
  // Global
  // ==========================================================================

  // 名前空間生成
  window.starterkit = window.starterkit || {};

  // ==========================================================================
  // Media Query
  // ==========================================================================

  // クラス定義
  window.starterkit.MediaQuery = class {
    constructor() {
      // ブレークポイント
      this.breakpoints = [
        { name: "sm", minWidth: "320px" },
        { name: "md", minWidth: "481px" },
        { name: "lg", minWidth: "769px" },
        { name: "xl", minWidth: "960px" },
        { name: "xxl", minWidth: "1000px" },
      ];

      // MediaQueryListオブジェクト
      this.matchMedia = new Map(this.breakpoints.map((element) => [element.name, window.matchMedia(`screen and (min-width: ${element.minWidth})`)]));
    }
  };

  // ==========================================================================
  // Collapse
  // ==========================================================================

  // クラス定義
  window.starterkit.Collapse = class {
    constructor(root, { triggers = "", body = "" } = {}) {
      // 親要素
      this.elems = {
        root,
      };

      // 子要素セレクタ
      this._selectors = {
        triggers,
        body,
      };

      // ステート
      this.state = {
        mediaQuery: {},
        overflowMode: null,
        overflowLineClamp: null,
        visibleMode: null,
        visibleMedia: {},
        isVisibleActive: null,
        isActive: null,
      };

      // インスタンス
      this.instances = {
        mediaQuery: new window.starterkit.MediaQuery(),
      };

      this._init();
    }

    _init() {
      this._getElems();
      this._setParams();
      this._createCustomEvents();
      this._setEvents();
      this._getMediaQuery();
      this.update();

      // インスタンス代入
      this.elems.root.collapse = this;

      // 状態反映: 初期化済み
      this.elems.root.classList.add("-initialized");

      // カスタムイベント発火
      this.elems.root.dispatchEvent(this._customEvents.init);
    }

    _getElems() {
      // 子要素取得
      this.elems.triggers = this.elems.root.querySelectorAll(this._selectors.triggers);
      this.elems.body = this.elems.root.querySelector(this._selectors.body);
    }

    _setParams() {
      // 初期値設定: overflowモード
      if (this.elems.root.classList.contains("-overflow")) {
        this.state.overflowMode = true;
        this.state.overflowLineClamp = parseInt(this.elems.body.dataset.lineClamp, 10);
      }

      // 初期値設定: 常時展開モード
      for (let [key, matchMedia] of this.instances.mediaQuery.matchMedia.entries()) {
        if (this.elems.root.classList.contains(`-visible-${key}`)) {
          this.state.visibleMode = true;
          this.state.visibleMedia[key] = true;
        }
      }

      // 初期値設定: 展開状態
      this.state.isActive = this.elems.root.classList.contains("-active");
    }

    _createCustomEvents() {
      const customEventInit = { detail: { collapse: this } };
      const customEventNames = ["init", "show", "hide", "change", "update"];

      // 配列からカスタムイベント生成
      this._customEvents = {};
      customEventNames.forEach((eventName) => {
        this._customEvents[eventName] = new CustomEvent(eventName, customEventInit);
      });
    }

    _setEvents() {
      // イベント登録: ボタン
      this.elems.triggers.forEach((trigger) => {
        trigger.addEventListener("click", this._onTriggerClick.bind(this));
      });

      // イベント登録: メディアクエリ
      for (let [key, matchMedia] of this.instances.mediaQuery.matchMedia.entries()) {
        matchMedia.addEventListener("change", this._onMediaQueryChange.bind(this));
      }
    }

    _getMediaQuery() {
      let isVisibleMediaMatch = false;

      for (let [key, matchMedia] of this.instances.mediaQuery.matchMedia.entries()) {
        this.state.mediaQuery[key] = matchMedia.matches;

        if (this.state.visibleMedia[key] && this.state.mediaQuery[key]) {
          isVisibleMediaMatch = true;
        }
      }

      this.state.isVisibleActive = this.state.visibleMode && isVisibleMediaMatch;
    }

    _onMediaQueryChange(event) {
      window.requestAnimationFrame(() => {
        this._getMediaQuery();

        this.update();
      });
    }

    _onTriggerClick(event) {
      // 常時展開モード時は無効化
      if (this.state.isVisibleActive) {
        return;
      }

      if (event) {
        event.preventDefault();
      }

      this.toggle();
    }

    show() {
      // 常時展開モード時は無効化
      if (this.state.isVisibleActive) {
        return false;
      }

      // アクティブ状態切り替え
      this.state.isActive = true;

      this.update();

      // カスタムイベント発火
      this.elems.root.dispatchEvent(this._customEvents.show);
      this.elems.root.dispatchEvent(this._customEvents.change);
    }

    hide() {
      // 常時展開モード時は無効化
      if (this.state.isVisibleActive) {
        return false;
      }

      // アクティブ状態切り替え
      this.state.isActive = false;

      this.update();

      // カスタムイベント発火
      this.elems.root.dispatchEvent(this._customEvents.hide);
      this.elems.root.dispatchEvent(this._customEvents.change);
    }

    toggle() {
      // アクティブ状態に応じてトグル
      if (this.state.isActive) {
        this.hide();
      } else {
        this.show();
      }
    }

    update() {
      // 常時展開モードオンかつ対象メディアクエリ
      if (this.state.isVisibleActive) {
        this.elems.root.classList.add("-active");
        this.elems.body.style.WebkitLineClamp = "";
      }
      // それ以外
      else {
        // 状態反映: overflowモード
        if (this.state.overflowMode) {
          if (this.state.isActive) {
            this.elems.root.classList.add("-active");
            this.elems.body.style.WebkitLineClamp = "";
          } else {
            this.elems.root.classList.remove("-active");
            this.elems.body.style.WebkitLineClamp = this.state.overflowLineClamp;
          }
        }
        // 状態反映: 通常モード
        else {
          if (this.state.isActive) {
            this.elems.root.classList.add("-active");
          } else {
            this.elems.root.classList.remove("-active");
          }
        }
      }

      // カスタムイベント発火
      this.elems.root.dispatchEvent(this._customEvents.update);
    }
  };

  // 要素初期化
  window.addEventListener("DOMContentLoaded", (event) => {
    document.querySelectorAll(".js-collapse").forEach((collapseElem) => {
      const collapse = new window.starterkit.Collapse(collapseElem, {
        triggers: ".js-collapse-trigger",
        body: ".js-collapse-body",
      });
      // console.log(collapse);
    });
  });

  // window.addEventListener("DOMContentLoaded", (event) => {
  //   document.querySelectorAll(".js-cardlist-search-collapse").forEach((collapseElem) => {
  //     const cardlistSearchCollapse = new window.starterkit.Collapse(collapseElem, {
  //       triggers: ".js-cardlist-search-toggle",
  //       body: ".js-cardlist-search-body",
  //     });
  //   });
  // });

  // ==========================================================================
  // Tab
  // ==========================================================================

  // クラス定義
  window.starterkit.Tab = class {
    constructor(root, { buttons = "", panels = "", list = "" } = {}) {
      // 親要素
      this.elems = {
        root,
      };

      // 子要素セレクタ
      this._selectors = {
        buttons,
        panels,
        list,
      };

      // ステート
      this.state = {
        // overflowMode: null,
        activeTabIndex: null,
        // isTouched: null,
      };

      this._init();
    }

    _init() {
      this._getElems();
      this._setParams();
      this._createCustomEvents();
      this._setEvents();
      this.update();

      // インスタンス代入
      this.elems.root.tab = this;

      // 状態反映: 初期化済み
      this.elems.root.classList.add("-initialized");

      // カスタムイベント発火
      this.elems.root.dispatchEvent(this._customEvents.init);
    }

    _getElems() {
      // 子要素取得
      this.elems.buttons = this.elems.root.querySelectorAll(this._selectors.buttons);
      this.elems.panels = this.elems.root.querySelectorAll(this._selectors.panels);
      this.elems.list = this.elems.root.querySelectorAll(this._selectors.list);
    }

    _setParams() {
      // 初期値設定: overflowモード
      // if (this.elems.root.classList.contains("-overflow")) {
      //   this.state.overflowMode = true;
      //   this.state.isTouched = false;
      // }

      // 初期値設定: 展開状態
      this.state.activeTabIndex = null;
      this.elems.buttons.forEach((button, i) => {
        if (button.classList.contains("-active")) {
          this.state.activeTabIndex = i;
        }
      });
    }

    _createCustomEvents() {
      const customEventInit = { detail: { tab: this } };
      const customEventNames = ["init", "change", "update"];

      // 配列からカスタムイベント生成
      this._customEvents = {};
      customEventNames.forEach((eventName) => {
        this._customEvents[eventName] = new CustomEvent(eventName, customEventInit);
      });
    }

    _setEvents() {
      // イベント登録: タッチ
      // if (this.state.overflowMode) {
      //   this.elems.root.addEventListener(
      //     "mousedown",
      //     this._onRootTouch.bind(this)
      //   );
      //   this.elems.root.addEventListener(
      //     "touchstart",
      //     this._onRootTouch.bind(this)
      //   );
      // }

      // イベント登録: ボタン
      this.elems.buttons.forEach((button) => {
        button.addEventListener("click", this._onButtonClick.bind(this));
      });
    }

    // _onRootTouch(event) {
    //   // タッチ済みフラグ
    //   this.state.isTouched = true;

    //   this.update();
    // }

    _onButtonClick(event) {
      if (event) {
        event.preventDefault();
      }

      // クリックタブ番号取得
      const tabIndex = Array.prototype.findIndex.call(this.elems.buttons, (button, i) => {
        return button === event.target;
      });

      // 切り替え処理実行
      this.change(tabIndex);
    }

    change(tabIndex) {
      // タブ番号セット
      this.state.activeTabIndex = tabIndex;

      this.update();

      // カスタムイベント発火
      this.elems.root.dispatchEvent(this._customEvents.change);
    }

    update() {
      // 状態反映: タッチ
      // if (this.state.overflowMode) {
      //   this.elems.root.classList.toggle("-touched", this.state.isTouched);
      // }

      // 状態反映: ボタン
      this.elems.buttons.forEach((button, i) => {
        button.classList.toggle("-active", i === this.state.activeTabIndex);
      });

      // 状態反映: パネル
      this.elems.panels.forEach((panel, i) => {
        // panel.classList.toggle("-active", i === this.state.activeTabIndex);

        if (i === this.state.activeTabIndex) {
          panel.style.visibility = "visible";
          panel.style.display = "block";

          setTimeout(() => {
            panel.classList.add("-active");
          }, 20);
        } else {
          panel.classList.remove("-active");
          panel.style.visibility = "hidden";
          panel.style.display = "none";
        }
      });

      // 状態反映: リスト
      this.elems.list.forEach((list, i) => {
        list.classList.toggle("-active", i === this.state.activeTabIndex);
      });

      // カスタムイベント発火
      this.elems.root.dispatchEvent(this._customEvents.update);
    }
  };

  // 要素初期化
  window.addEventListener("DOMContentLoaded", (event) => {
    document.querySelectorAll(".js-tab").forEach((tabElem) => {
      const tab = new window.starterkit.Tab(tabElem, {
        list: ".js-tab-list",
        buttons: ".js-tab-button",
        panels: ".js-tab-panel",
      });
      // console.log(tab);
    });
  });

  // ==========================================================================
  // Overflow
  // ==========================================================================

  // クラス定義
  window.starterkit.Overflow = class {
    constructor(root, {} = {}) {
      // 親要素
      this.elems = {
        root,
      };

      // ステート
      this.state = {
        isTouched: null,
      };

      this._init();
    }

    _init() {
      this._setParams();
      this._createCustomEvents();
      this._setEvents();
      this.update();

      // インスタンス代入
      this.elems.root.overflow = this;

      // 状態反映: 初期化済み
      this.elems.root.classList.add("-initialized");

      // カスタムイベント発火
      this.elems.root.dispatchEvent(this._customEvents.init);
    }

    _setParams() {
      // 初期値設定: タッチ状態
      this.state.isTouched = false;
    }

    _createCustomEvents() {
      const customEventInit = { detail: { overflow: this } };
      const customEventNames = ["init", "update"];

      // 配列からカスタムイベント生成
      this._customEvents = {};
      customEventNames.forEach((eventName) => {
        this._customEvents[eventName] = new CustomEvent(eventName, customEventInit);
      });
    }

    _setEvents() {
      // イベント登録: タッチ
      this.elems.root.addEventListener("mousedown", this._onRootTouch.bind(this));
      this.elems.root.addEventListener("touchstart", this._onRootTouch.bind(this));
    }

    _onRootTouch(event) {
      // タッチ済みフラグ
      this.state.isTouched = true;

      this.update();
    }

    update() {
      // 状態反映: タッチ
      this.elems.root.classList.toggle("-touched", this.state.isTouched);

      // カスタムイベント発火
      this.elems.root.dispatchEvent(this._customEvents.update);
    }
  };

  // 要素初期化
  window.addEventListener("DOMContentLoaded", (event) => {
    document.querySelectorAll(".js-overflow").forEach((overflowElem) => {
      const overflow = new window.starterkit.Overflow(overflowElem, {});
      // console.log(overflow);
    });
  });

  // ==========================================================================
  // Cookie
  // ==========================================================================

  window.addEventListener("DOMContentLoaded", (event) => {
    const docCookie = document.cookie;
    const cookieElement = document.getElementById("js-cookie");
    const cookieAccept = document.getElementById("js-cookie-accept");
    const cookieDeny = document.getElementById("js-cookie-deny");
    // const cookieConsentDate = 30; // 確認用保存期間
    const cookieConsentDate = 60 * 60 * 24 * 365; // 保存期間1年（秒数）

    if (cookieElement != null) {
      if (docCookie.split(";").some((item) => item.trim().startsWith("cookie_consent_status="))) {
        cookieElement.remove();
      } else {
        cookieAccept.addEventListener("click", () => {
          cookieElement.remove();
          document.cookie = "cookie_consent_status=true; max-age=" + cookieConsentDate;
          alert("同意後の処理は、各プロジェクト毎の案件に合わせて処理してください。");
        });

        cookieDeny.addEventListener("click", () => {
          cookieElement.remove();
          document.cookie = "cookie_consent_status=false; max-age=" + cookieConsentDate;
          alert("拒否後の処理は、各プロジェクト毎の案件に合わせて処理してください。");
        });
      }
    }

    if (docCookie.split(";").some((item) => item.includes("cookie_consent_status=true"))) {
      console.log("cookie同意してます");
    }

    if (docCookie.split(";").some((item) => item.includes("cookie_consent_status=false"))) {
      console.log("cookie拒否してます");
    }
  });

  // ==========================================================================
  // Header
  // ==========================================================================

  // クラス定義
  window.starterkit.Header = class {
    constructor(root, { button = "", menu = "" } = {}) {
    // constructor(root, { button = "", menu = "", menuInner = "" } = {}) {
      // 親要素
      this.elems = {
        html: document.documentElement,
        root,
      };

      // 子要素セレクタ
      this._selectors = {
        button,
        menu,
        // menuInner,
      };

      // ステート
      this.state = {
        mediaQuery: {},
        stickyMode: null,
        isWindowScrolled: null,
        isActive: null,
      };
      this._lastState = _.cloneDeep(this.state);

      // インスタンス
      this.instances = {
        mediaQuery: new window.starterkit.MediaQuery(),
      };

      this._init();
    }

    _init() {
      this._getElems();
      this._setParams();
      this._createCustomEvents();
      this._setEvents();
      this._getWindowScroll();
      this._getMediaQuery();
      this.update();

      // インスタンス代入
      this.elems.root.header = this;

      // 状態反映: 初期化済み
      this.elems.root.classList.add("-initialized");

      // カスタムイベント発火
      this.elems.root.dispatchEvent(this._customEvents.init);
    }

    _getElems() {
      // 子要素取得
      this.elems.button = this.elems.root.querySelector(this._selectors.button);
      this.elems.menu = this.elems.root.querySelector(this._selectors.menu);
      // this.elems.menuInner = this.elems.root.querySelector(this._selectors.menuInner);
    }

    _setParams() {
      // 初期値設定: stickyモード
      if (this.elems.root.classList.contains("-sticky-top")) {
        this.state.stickyMode = true;
      }
    }

    _createCustomEvents() {
      const customEventInit = { detail: { header: this } };
      const customEventNames = ["init", "menuShow", "menuHide", "menuChange", "scrollChange", "update"];

      // 配列からカスタムイベント生成
      this._customEvents = {};
      customEventNames.forEach((eventName) => {
        this._customEvents[eventName] = new CustomEvent(eventName, customEventInit);
      });
    }

    _setEvents() {
      // イベント登録: ウィンドウ
      window.addEventListener("scroll", this._onWindowScroll.bind(this));

      // イベント登録: メディアクエリ
      for (let [key, matchMedia] of this.instances.mediaQuery.matchMedia.entries()) {
        matchMedia.addEventListener("change", this._onMediaQueryChange.bind(this));
      }

      // イベント登録: ボタン
      this.elems.button.addEventListener("click", this._onButtonClick.bind(this));

      // イベント登録: メニュー
      this.elems.menu.addEventListener("click", this._onMenuClick.bind(this));
    }

    _getWindowScroll() {
      this.state.isWindowScrolled = window.scrollY > 0;
    }

    _getMediaQuery() {
      for (let [key, matchMedia] of this.instances.mediaQuery.matchMedia.entries()) {
        this.state.mediaQuery[key] = matchMedia.matches;
      }
    }

    _onWindowScroll(event) {
      window.requestAnimationFrame(() => {
        this._getWindowScroll();

        this.update();
      });
    }

    _onMediaQueryChange(event) {
      window.requestAnimationFrame(() => {
        this._getMediaQuery();

        this.update();
      });
    }

    _onButtonClick(event) {
      if (event) {
        event.preventDefault();
      }

      this.menuToggle();
    }

    _onMenuClick(event) {
      const targetHref = event.target.href;
      if (!targetHref) {
        return;
      }

      const currentUrl = new URL(window.location.href);
      const targetUrl = new URL(targetHref);

      const isMatchOrigin = targetUrl.origin === currentUrl.origin;
      const isMatchPathname = targetUrl.pathname === currentUrl.pathname;
      const isMatchSearch = targetUrl.search === currentUrl.search;
      const hasHash = !!targetUrl.hash;

      if (isMatchOrigin && isMatchPathname && isMatchSearch && hasHash) {
        this.menuHide();
      }
    }

    menuShow() {
      // アクティブ状態切り替え
      this.state.isActive = true;

      this.update();

      // カスタムイベント発火
      this.elems.root.dispatchEvent(this._customEvents.menuShow);
      this.elems.root.dispatchEvent(this._customEvents.menuChange);
    }

    menuHide() {
      // アクティブ状態切り替え
      this.state.isActive = false;

      this.update();

      // カスタムイベント発火
      this.elems.root.dispatchEvent(this._customEvents.menuHide);
      this.elems.root.dispatchEvent(this._customEvents.menuChange);
    }

    menuToggle() {
      // アクティブ状態に応じてトグル
      if (this.state.isActive) {
        this.menuHide();
      } else {
        this.menuShow();
      }
    }

    update() {
      // xxl以上
      if (this.state.mediaQuery.xxl) {
        this.state.isActive = false;
        this.elems.button.classList.remove("-active");

        // スクロールロック
        // if (this.state.stickyMode) {
        bodyScrollLock.enableBodyScroll(this.elems.menu);
        // }

        this.elems.menu.classList.remove("-animated", "-active");
        this.elems.menu.style.height = "";

        if (this.state.stickyMode && this.state.isWindowScrolled !== this._lastState.isWindowScrolled) {
          if (this._lastState.isWindowScrolled === null) {
            // クラス変更
            this.elems.html.classList.toggle("-scrolled", this.state.isWindowScrolled);
            this.elems.root.classList.toggle("-scrolled", this.state.isWindowScrolled);
          } else {
            // トランジション終了時処理セット
            this.elems.root.addEventListener(
              "transitionend",
              (event) => {
                this.elems.root.classList.remove("-animated");
              },
              { once: true }
            );

            // トランジション準備
            this.elems.root.classList.add("-animated");

            // クラス変更
            this.elems.html.classList.toggle("-scrolled", this.state.isWindowScrolled);
            this.elems.root.classList.toggle("-scrolled", this.state.isWindowScrolled);
            this.elems.root.classList.remove("-anchor", this.state.isWindowScrolled);
          }

          // カスタムイベント発火
          this.elems.root.dispatchEvent(this._customEvents.scrollChange);
        }
      }
      // xl以下
      else {
        // this.elems.html.classList.remove("-scrolled");
        // this.elems.root.classList.remove("-scrolled");

        if (this.state.stickyMode && this.state.isWindowScrolled !== this._lastState.isWindowScrolled) {
          if (this._lastState.isWindowScrolled === null) {
            // クラス変更
            this.elems.html.classList.toggle("-scrolled", this.state.isWindowScrolled);
            this.elems.root.classList.toggle("-scrolled", this.state.isWindowScrolled);
          } else {
            // トランジション終了時処理セット
            this.elems.root.addEventListener(
              "transitionend",
              (event) => {
                this.elems.root.classList.remove("-animated");
              },
              { once: true }
            );

            // トランジション準備
            this.elems.root.classList.add("-animated");

            // クラス変更
            this.elems.html.classList.toggle("-scrolled", this.state.isWindowScrolled);
            this.elems.root.classList.toggle("-scrolled", this.state.isWindowScrolled);
            this.elems.root.classList.remove("-anchor", this.state.isWindowScrolled);
          }

          // カスタムイベント発火
          this.elems.root.dispatchEvent(this._customEvents.scrollChange);
        }

        // 開く
        if (this.state.isActive) {
          this.elems.button.classList.add("-active");

          // スクロールロック
          // if (this.state.stickyMode) {
          bodyScrollLock.disableBodyScroll(this.elems.menu);
          document.documentElement.style.cssText = "overflow: hidden;";
          // }

          // 変更時のみ
          if (this.state.isActive !== this._lastState.isActive) {
            // トランジション終了時処理セット
            // this.elems.menu.addEventListener(
            //   "transitionend",
            //   (event) => {
            //     this.elems.menu.classList.remove("-animated");
            // this.elems.menu.style.height = "";
            // this.elems.menu.classList.add("-active");

            // カスタムイベント発火
            //     this.elems.root.dispatchEvent(this._customEvents.update);
            //   },
            //   { once: true }
            // );

            // メニュー高さ取得
            // this.elems.menu.classList.add("-preview");
            // const menuHeight = this.elems.menu.offsetHeight;
            // this.elems.menu.classList.remove("-preview");

            // トランジション準備
            // this.elems.menu.style.height = 0;
            // this.elems.menu.classList.add("-animated");

            // レンダリング反映を待って高さをセット
            // window.requestAnimationFrame(() => {
            //   this.elems.menu.style.height = `${menuHeight}px`;
            // });

            // メニューを表示するボタンをクリックしたとき
            $(".js-header-menu").stop(true, true).css({ display: "block" }).animate({ opacity: 1 }, 300, "easeInOutQuad");
            // const scrollTop = $(window).scrollTop();
            // $(document.documentElement).css({ position: "fixed", top: -scrollTop, left: 0, right: 0, overflow: "hidden" });
          }
        }
        // 閉じる
        else {
          this.elems.button.classList.remove("-active");

          // スクロールロック
          // if (this.state.stickyMode) {
          if (!$(".p-top-movie-modal").hasClass("is-active")) {
            // bodyScrollLock.enableBodyScroll(this.elems.menu);
            // console.log("aaa");
            // document.documentElement.style.cssText = "overflow: auto;";
          }
          // }

          // 変更時のみ
          if (this.state.isActive !== this._lastState.isActive) {
            // トランジション終了時処理セット
            // this.elems.menu.addEventListener(
            //   "transitionend",
            //   (event) => {
            //     this.elems.menu.classList.remove("-animated");
            //     this.elems.menu.style.height = "";

            // カスタムイベント発火
            //     this.elems.root.dispatchEvent(this._customEvents.update);
            //   },
            //   { once: true }
            // );

            // メニュー高さ取得
            // this.elems.menu.classList.add("-preview");
            // const menuHeight = this.elems.menu.offsetHeight;
            // this.elems.menu.classList.remove("-preview");

            // トランジション準備
            // this.elems.menu.classList.remove("-active");
            // this.elems.menu.style.height = `${menuHeight}px`;
            // this.elems.menu.classList.add("-animated");

            // レンダリング反映を待って高さをセット
            // window.requestAnimationFrame(() => {
            //   this.elems.menu.style.height = 0;
            // });

            // メニューを閉じるボタンをクリックしたとき
            bodyScrollLock.enableBodyScroll(this.elems.menu);
            document.documentElement.style.cssText = "overflow: auto;";
            $(".js-header-menu")
              .stop(true, true)
              .animate({ opacity: 0 }, 300, "easeInOutQuad")
              .queue(function () {
            // console.log("aaa");
                // const scrollTop = Math.abs(parseInt($(document.documentElement).css('top')));
                // $(document.documentElement).css({ position: "", top: "", left: "", right: "", overflow: "auto" });
                // $(window).scrollTop(scrollTop, 0);
                // $(this).animate({ opacity: 0 }, 300, "easeInOutQuad");
                $(this).removeClass("-active");
                $(this).css({ display: "none" }).dequeue();
              });
              
          }
        }
      }

      // 直近のステートを記憶
      this._lastState = _.cloneDeep(this.state);

      // カスタムイベント発火
      this.elems.root.dispatchEvent(this._customEvents.update);
    }
  };

  // 要素初期化
  window.addEventListener("DOMContentLoaded", (event) => {
    document.querySelectorAll(".js-header").forEach((headerElem) => {
      const header = new window.starterkit.Header(headerElem, {
        button: ".js-header-button",
        menu: ".js-header-menu",
        // menuInner: ".js-header-menu-inner",
      });
      // console.log(header);
    });
  });

  // ==========================================================================
  // Scroll To Top Button
  // ==========================================================================

  // クラス定義
  window.starterkit.ScrollToTopButton = class {
    constructor(root) {
      // 親要素
      this.elems = {
        root,
      };

      // ステート
      this.state = {
        staticMode: null,
        isWindowScrolled: null,
      };
      this._lastState = _.cloneDeep(this.state);

      this._init();
    }

    _init() {
      this._setParams();
      this._createCustomEvents();
      this._setEvents();
      this._getWindowScroll();
      this.update();

      // インスタンス代入
      this.elems.root.scrollToTopButton = this;

      // 状態反映: 初期化済み
      this.elems.root.classList.add("-initialized");

      // カスタムイベント発火
      this.elems.root.dispatchEvent(this._customEvents.init);
    }

    _setParams() {
      // 初期値設定: staticモード
      if (this.elems.root.classList.contains("-static")) {
        this.state.staticMode = true;
      }
    }

    _createCustomEvents() {
      const customEventInit = { detail: { scrollToTopButton: this } };
      const customEventNames = ["init", "update"];

      // 配列からカスタムイベント生成
      this._customEvents = {};
      customEventNames.forEach((eventName) => {
        this._customEvents[eventName] = new CustomEvent(eventName, customEventInit);
      });
    }

    _setEvents() {
      // イベント登録: ウィンドウ
      window.addEventListener("scroll", this._onWindowScroll.bind(this));
    }

    _getWindowScroll() {
      this.state.isWindowScrolled = window.scrollY > 0;
    }

    _onWindowScroll(event) {
      window.requestAnimationFrame(() => {
        this._getWindowScroll();

        this.update();
      });
    }

    update() {
      if (!this.state.staticMode && this.state.isWindowScrolled !== this._lastState.isWindowScrolled) {
        if (this.state.isWindowScrolled) {
          this.elems.root.addEventListener(
            "animationend",
            () => {
              this.elems.root.classList.replace("-showing", "-show");
            },
            { once: true }
          );

          this.elems.root.classList.add("-showing");
        } else {
          this.elems.root.addEventListener(
            "animationend",
            () => {
              this.elems.root.classList.remove("-hiding");
            },
            { once: true }
          );

          this.elems.root.classList.replace("-show", "-hiding");
        }
      }

      // 直近のステートを記憶
      this._lastState = _.cloneDeep(this.state);

      // カスタムイベント発火
      this.elems.root.dispatchEvent(this._customEvents.update);
    }
  };

  // 要素初期化
  window.addEventListener("DOMContentLoaded", (event) => {
    document.querySelectorAll(".js-scrolltotopbutton").forEach((scrollToTopButtonElem) => {
      const scrollToTopButton = new window.starterkit.ScrollToTopButton(scrollToTopButtonElem);
      // console.log(scrollToTopButton);
    });
  });

  // ==========================================================================
  // Floating Banner
  // ==========================================================================

  // クラス定義
  window.starterkit.FloatingBanner = class {
    constructor(root) {
      // 親要素
      this.elems = {
        root,
      };

      // ステート
      this.state = {
        isWindowScrolled: null,
        showScrollPosition: 500,
      };
      this._lastState = _.cloneDeep(this.state);

      this._init();
    }

    _init() {
      this._createCustomEvents();
      this._setEvents();
      this._getWindowScroll();
      this.update();

      // インスタンス代入
      this.elems.root.floatingBanner = this;

      // 状態反映: 初期化済み
      this.elems.root.classList.add("-initialized");

      // カスタムイベント発火
      this.elems.root.dispatchEvent(this._customEvents.init);
    }

    _createCustomEvents() {
      const customEventInit = { detail: { floatingBanner: this } };
      const customEventNames = ["init", "update"];

      // 配列からカスタムイベント生成
      this._customEvents = {};
      customEventNames.forEach((eventName) => {
        this._customEvents[eventName] = new CustomEvent(eventName, customEventInit);
      });
    }

    _setEvents() {
      // イベント登録: ウィンドウ
      window.addEventListener("scroll", this._onWindowScroll.bind(this));
    }

    _getWindowScroll() {
      this.state.isWindowScrolled = window.scrollY >= this.state.showScrollPosition;
    }

    _onWindowScroll(event) {
      window.requestAnimationFrame(() => {
        this._getWindowScroll();

        this.update();
      });
    }

    update() {
      if (this.state.isWindowScrolled !== this._lastState.isWindowScrolled) {
        if (this.state.isWindowScrolled) {
          this.elems.root.addEventListener(
            "animationend",
            () => {
              this.elems.root.classList.replace("-showing", "-show");
            },
            { once: true }
          );

          this.elems.root.classList.add("-showing");
        } else {
          this.elems.root.addEventListener(
            "animationend",
            () => {
              this.elems.root.classList.remove("-hiding");
            },
            { once: true }
          );

          this.elems.root.classList.replace("-show", "-hiding");
        }
      }

      // 直近のステートを記憶
      this._lastState = _.cloneDeep(this.state);

      // カスタムイベント発火
      this.elems.root.dispatchEvent(this._customEvents.update);
    }
  };

  // 要素初期化
  window.addEventListener("DOMContentLoaded", (event) => {
    document.querySelectorAll(".js-floatingbanner").forEach((floatingBannerElem) => {
      const floatingBanner = new window.starterkit.FloatingBanner(floatingBannerElem);
      // console.log(floatingBanner);
    });
  });

  // ==========================================================================
  // Site: Utilities ユーティリティー
  // ==========================================================================

  // setWindowEvents
  // ウィンドウイベント一括指定
  const setWindowEvents = ({ resize, scroll, load } = {}) => {
    window.addEventListener("resize", () => {
      window.requestAnimationFrame(() => {
        if (resize) {
          resize();
        }
        if (scroll) {
          scroll();
        }
      });
    });

    window.addEventListener("scroll", () => {
      window.requestAnimationFrame(() => {
        if (scroll) {
          scroll();
        }
      });
    });

    window.addEventListener("load", () => {
      if (resize) {
        resize();
      }
      if (scroll) {
        scroll();
      }
      if (load) {
        load();
      }
    });

    if (resize) {
      resize();
    }
    if (scroll) {
      scroll();
    }
  };

  // ==========================================================================
  // 共通: スクロールバーの幅取得設定
  // ==========================================================================

  let scrollbarWidth;

  $(function () {
    scrollbarWidth = window.innerWidth - document.body.clientWidth;

    const onResize = () => {
      scrollbarWidth = window.innerWidth - document.body.clientWidth;
    };

    setWindowEvents({
      resize: onResize,
      scroll: null,
      load: null,
    });
  });

  // ==========================================================================
  // ハンバーガーボタンの高さ調整
  // ==========================================================================

  let siteHeight;

  $(function () {
    setTimeout(function() {
      siteHeight = $(".c-header").outerHeight() + $(".l-main").outerHeight() + $(".c-footer").outerHeight();
      $(".c-header__main-button").height(siteHeight);
    }, 1000);

    const onResize = () => {
      siteHeight = $(".c-header").outerHeight() + $(".l-main").outerHeight() + $(".c-footer").outerHeight();
      $(".c-header__main-button").height(siteHeight);
    };

    setWindowEvents({
      resize: onResize,
      scroll: null,
      load: null,
    });
  });

  // ==========================================================================
  // 商品情報スライダーSP
  // ==========================================================================

  $(function () {
    const swiperTopSP = new Swiper(".js-swiper-sp", {
      loop: true,
      pagination: {
        el: ".p-top-slide-sp__pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".p-top-slide-sp__next",
        prevEl: ".p-top-slide-sp__prev",
      },
    });
  });

  // ==========================================================================
  // 商品情報スライダーPC
  // ==========================================================================

  $(function () {
    const swiperTopPC = new Swiper(".js-swiper-pc", {
      slidesPerView: "auto",
      freeMode: {
        enabled: true,
        momentumRatio: 0.3,
        momentumVelocityRatio: 0.35,
      },
      scrollbar: {
        el: ".p-top-slide-pc__scrollbar",
        hide: false,
        draggable: true,
      },
    });
  });

  // ==========================================================================
  // 商品情報スライダーモーダルPC
  // ==========================================================================

  // $(function () {
  //   const swiperTopModalPC = new Swiper(".js-swiper-modal-pc", {
  //     loop: true,
  //     navigation: {
  //       nextEl: ".p-top-slide-modal-pc__next",
  //       prevEl: ".p-top-slide-modal-pc__prev",
  //     },
  //   });

  //   const modal = document.querySelectorAll(".js-modal")[0];
  //   const modalOpenBtns = document.querySelectorAll(".js-modal-open");
  //   const modalCloseBtns = document.querySelectorAll(".js-modal-close");

  //   // モーダルを表示するボタンをクリックしたとき
  //   modalOpenBtns.forEach((modalOpenBtn) => {
  //     modalOpenBtn.addEventListener("click", () => {
  //       scrollbarWidth = window.innerWidth - document.body.clientWidth;
  //       $("body").css({ "padding-right": scrollbarWidth + "px" });
  //       const modalIndex = modalOpenBtn.dataset.slideIndex;
  //       swiperTopModalPC.slideTo(modalIndex, 0);
  //       const target = document.querySelector(".js-modal");
  //       bodyScrollLock.disableBodyScroll(target);
  //       document.documentElement.style.cssText = "overflow: hidden;";
  //       modal.classList.add("is-active");
  //     });
  //   });

  //   // モーダルを閉じるボタンをクリックしたとき
  //   modalCloseBtns.forEach((modalCloseBtn) => {
  //     modalCloseBtn.addEventListener("click", () => {
  //       $("body").css({ "padding-right": "" });
  //       const target = document.querySelector(".js-modal");
  //       bodyScrollLock.enableBodyScroll(target);
  //       document.documentElement.style.cssText = "overflow: auto;";

  //       $(".js-modal")
  //         .animate({ opacity: 0 }, 200, "easeInOutQuad")
  //         .queue(function () {
  //           $(this).removeClass("is-active");
  //           $(this).css({ opacity: "" }).dequeue();
  //         });
  //     });
  //   });
  // });

  // ==========================================================================
  // 動画モーダル
  // ==========================================================================

  $(function () {
    if ($(".js-modal-movie-id")[0]) {
      const id = $(".js-modal-movie-id").attr('data-id');
      const speed = 0;
      const modalMovie = document.querySelectorAll(".js-modal-movie")[0];
      const modalMovieOverlay = document.querySelectorAll(".js-modal-movie__overlay")[0];
      const modalMovieOpenBtns = document.querySelectorAll(".js-modal-movie-open");
      const modalMovieCloseBtns = document.querySelectorAll(".js-modal-movie-close");
      const $html = $(document.documentElement);
      const mediaQuery = new window.starterkit.MediaQuery();
      // const isMediaUpLg = mediaQuery.matchMedia.get("lg").matches;
      let scrollTop;
      const device = document.documentElement.getAttribute("class");

      modalMovieOpenBtns.forEach((modalMovieOpenBtn) => {
        modalMovieOpenBtn.addEventListener("click", () => {
          scrollbarWidth = window.innerWidth - document.body.clientWidth;

          if (device.includes("mobile") || device.includes("tablet")) {
            scrollTop = $(window).scrollTop();
            $html.css({ "padding-right": scrollbarWidth + "px", position: "fixed", top: -scrollTop, left: 0, right: 0, overflow: "hidden" });
          } else {
            $("body").css({ "padding-right": scrollbarWidth });
            document.documentElement.style.cssText = "overflow: hidden;";
          }

          const target = document.querySelector(".p-top-movie-modal");
          bodyScrollLock.disableBodyScroll(target);
          modalMovie.classList.add("is-active");
          modalMovieOverlay.classList.add("is-active");
          $(".js-modal-movie-id").append('<iframe src="https://www.youtube.com/embed/' + id + "?rel=0&start=" + speed + '&autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>');
        });
      });

      modalMovieCloseBtns.forEach((modalMovieCloseBtn) => {
        modalMovieCloseBtn.addEventListener("click", () => {
          if (device.includes("mobile") || device.includes("tablet")) {
            $html.css({ "padding-right": "", position: "", top: "", left: "", right: "", overflow: "auto" });
            $(window).scrollTop(scrollTop, 0);
          } else {
            $("body").css({ "padding-right": "" });
            document.documentElement.style.cssText = "overflow: auto;";
          }

          const target = document.querySelector(".p-top-movie-modal");
          bodyScrollLock.enableBodyScroll(target);

          $(".js-modal-movie")
            .animate({ opacity: 0 }, 200, "easeInOutQuad")
            .queue(function () {
              $(".js-modal-movie-id").empty();
              $(this).removeClass("is-active");
              $(this).css({ opacity: "" }).dequeue();
            });

          $(".js-modal-movie__overlay")
            .animate({ opacity: 0 }, 200, "easeInOutQuad")
            .queue(function () {
              $(".js-modal-movie-id").empty();
              $(this).removeClass("is-active");
              $(this).css({ opacity: "" }).dequeue();
            });
        });
      });
    }
  });

  // ==========================================================================
  // ページ内リンクスクロール
  // ==========================================================================

  $(function () {
    $('a[href^="#"]:not(a[href="#"],a.js-rulefaq-list-link,a.js-rulefaq-nav-list-link,a.p-cardlist-result-pagination__link)').click(function () {
      const speed = 500;
      const href = $(this).attr("href");
      const target = $(href == "#" || href == "" ? "html" : href);
      let position = target.offset().top;

      $("html, body").animate({ scrollTop: position }, speed, "swing");
      // return false;
    });

    $('a.js-rulefaq-list-link,a.js-rulefaq-nav-list-link').click(function () {
      const speed = 500;
      const href = $(this).attr("href");
      const target = $(href == "#" || href == "" ? "html" : href);
      let position = target.offset().top;
      const mediaQuery = new window.starterkit.MediaQuery();
      const isMediaUpLG = mediaQuery.matchMedia.get("lg").matches;

      if (isMediaUpLG) {
        const headerHeight = $(".js-header").outerHeight();
        position = position - headerHeight + 72;
      }

      $("html, body").animate({ scrollTop: position }, speed, "swing");
      // return false;
    });

    // $('a.js-rulefaq-nav-list-link').click(function () {
    //   const speed = 500;
    //   const href = $(this).attr("href");
    //   const target = $(href == "#" || href == "" ? "html" : href);
    //   let position = target.offset().top;
    //   const mediaQuery = new window.starterkit.MediaQuery();
    //   const isMediaUpLG = mediaQuery.matchMedia.get("lg").matches;

    //   if (isMediaUpLG) {
    //     const headerHeight = $(".js-header").outerHeight();
    //     position = position - headerHeight + 72;
    //   }

    //   $("html, body").animate({ scrollTop: position }, speed, "swing");
    //   // return false;
    // });
  });


  // $(function () {
  //   $('.c-header__aside-logo').click(function () {
  //     const target = document.querySelector(".js-header-button");
  //     target.dispatchEvent(new PointerEvent("click"));
  //   });
  // });





  // ==========================================================================
  // closeボタン
  // ==========================================================================


  // $(function () {
  //   $('.js-header-close-button').click(function () {
  //     const target = document.querySelector(".js-header-button");
  //     target.dispatchEvent(new PointerEvent("click"));
  //   });
  // });

  // $(function () {
  //   $('.js-header-close-button').click(function () {
  //     const target = document.querySelector(".js-header-button");
  //     target.dispatchEvent(new PointerEvent("click"));
  //   });
  // });
  $(function () {
    if (document.querySelector(".js-header-close-button")) {
      document.querySelector(".js-header-close-button").addEventListener ( "click", (e) => {
        e.preventDefault();
        document.querySelector(".js-header-button").click();
        // bodyScrollLock.enableBodyScroll(this.elems.menu);
        // document.documentElement.style.cssText = "overflow: auto;";
      });
    }
  });
//   $(function () {
//   document.querySelector(".js-header-close-button").onclick = function () {
//     document.querySelector(".js-header-button").click();
// };
//   });

  // btn1.addEventListener ( "click", () => { 
  //   btn2.click();
  //   console.log('btn1をクリック') 
  // });



  // ==========================================================================
  // HOME: メインビジュアルスライダー、今月の主な新製品情報スライダー、製品化決定スライダー、掲載物アーカイブスライダー
  // ==========================================================================

  $(function () {
    const swiperBnr = new Swiper(".js-swiper-bnr", {
      loop: true,
      roundLengths: true,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 5,
      },
      speed: 600,
      // spaceBetween: '3.2vw',
      // spaceBetween: 10,
      slidesPerView: 1.112,
      // slidesPerView: 1.11275964392,
      // slidesPerView: 1.15384615385,
      centeredSlides : true,
      autoplay: {
        delay: 10000,
        disableOnInteraction: false,
        pauseOnMouseEnter:true,
      },
      pagination: {
        el: ".p-top-bnr__pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".p-top-bnr__next",
        prevEl: ".p-top-bnr__prev",
      },
      breakpoints: {
        769: {
          spaceBetween: 25,
          slidesPerView: 2,
          centeredSlides : false,
          // slidesPerView: "auto",
        },
      },
      on: {
        afterInit: function (swiper) {
          swiper.autoplay.stop();
          setTimeout(function () {
            swiper.autoplay.start();
          }, 600);
        },
      },
    });
  });

  // ==========================================================================
  // NEWS: メインビジュアルスライダー
  // ==========================================================================

  $(function () {
    const swiperNews = new Swiper(".js-swiper-news", {
      loop: true,
      roundLengths: true,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 3,
      },
      // speed: 600,
      // spaceBetween: '3.2vw',
      // spaceBetween: 10,
      // slidesPerView: 1.08695652174,
      // slidesPerView: 1.11275964392,
      // slidesPerView: 1.15384615385,
      // centeredSlides : true,
      // autoplay: {
      //   delay: 10000,
      //   disableOnInteraction: false,
      //   pauseOnMouseEnter:true,
      // },
      pagination: {
        el: ".p-news-pickup__pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".p-news-pickup__next",
        prevEl: ".p-news-pickup__prev",
      },
      // breakpoints: {
      //   769: {
      //     // spaceBetween: 25,
      //     // slidesPerView: 2,
      //     centeredSlides : false,
      //     // slidesPerView: "auto",
      //   },
      // },
      // on: {
      //   afterInit: function (swiper) {
      //     swiper.autoplay.stop();
      //     setTimeout(function () {
      //       swiper.autoplay.start();
      //     }, 600);
      //   },
      // },
    });
  });



  // ==========================================================================
  // HOME: 今月の主な新製品情報スライダー、製品化決定スライダー、掲載物アーカイブスライダー 画像の遅延読み込み
  // 製品詳細: 関連製品スライダー 画像の遅延読み込み
  // ==========================================================================

  // $(function () {
  //   lazyload();
  // });


  // ==========================================================================
  // 共通: ヘッダーPC current判定
  // ==========================================================================

  $(function () {
    const directoryName = window.location.pathname.split("/")[3];

    $(".c-header__aside-main-item").each(function () {
      const $menuId = $(this).data("menu-id");
      const menuIdMax = $menuId.length;

      for (let i = 0; i < menuIdMax; i++) {
        if (directoryName == $menuId[i]) {
          $(this).addClass("-current");
        }
      }
    });
  });

  // ==========================================================================
  // ルール・Q&A、イベント current判定
  // ==========================================================================

  $(function () {
    const directoryName = window.location.pathname.split("/")[4];

    $(".js-rulefaq-nav-list-item,.js-event-nav-list-item").each(function () {
      const $menuId = $(this).data("menu-id");
      const menuIdMax = $menuId.length;

      for (let i = 0; i < menuIdMax; i++) {
        if (directoryName == $menuId[i]) {
          $(this).addClass("-current");
        }
      }
    });
  });

  // ==========================================================================
  // ストーリーモーダルPC
  // ==========================================================================

  $(function () {
    const swiperStory = new Swiper(".js-swiper-story", {
      loop: true,
      navigation: {
        nextEl: ".p-story-slide__next",
        prevEl: ".p-story-slide__prev",
      },
    });

    const modal = document.querySelectorAll(".js-modal")[0];
    const modalOpenBtns = document.querySelectorAll(".js-modal-open");
    const modalCloseBtns = document.querySelectorAll(".js-modal-close");

    // // モーダルを表示するボタンをクリックしたとき
    modalOpenBtns.forEach((modalOpenBtn) => {
      modalOpenBtn.addEventListener("click", () => {
        scrollbarWidth = window.innerWidth - document.body.clientWidth;
        $("body").css({ "padding-right": scrollbarWidth + "px" });
        const modalIndex = modalOpenBtn.dataset.slideIndex;
        swiperStory.slideTo(modalIndex, 0);
        const target = document.querySelector(".js-modal");
        bodyScrollLock.disableBodyScroll(target);
        document.documentElement.style.cssText = "overflow: hidden;";
        modal.classList.add("is-active");
      });
    });

    // // モーダルを閉じるボタンをクリックしたとき
    modalCloseBtns.forEach((modalCloseBtn) => {
      modalCloseBtn.addEventListener("click", () => {
        $("body").css({ "padding-right": "" });
        const target = document.querySelector(".js-modal");
        bodyScrollLock.enableBodyScroll(target);
        document.documentElement.style.cssText = "overflow: auto;";

        $(".js-modal")
          .animate({ opacity: 0 }, 200, "easeInOutQuad")
          .queue(function () {
            $(this).removeClass("is-active");
            $(this).css({ opacity: "" }).dequeue();
          });
      });
    });
  });



  // ==========================================================================
  // ストーリーカルーセル
  // ==========================================================================

  $(function () {
    const swiperStory = new Swiper(".js-carousel-story", {
      modules: [EffectCarousel],
      effect: 'carousel',
      carouselEffect: {
        opacityStep: 0.33,
        scaleStep: 0.5,
        sideSlides: 1,
      },
      grabCursor: true,
      loop: true,
      speed: 500,
      // loopAdditionalSlides: 1,
      slidesPerView: 'auto',
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 3,
      },
      navigation: {
        nextEl: ".p-story-carousel__next",
        prevEl: ".p-story-carousel__prev",
      },
      pagination: {
        el: ".p-story-carousel__pagination",
        clickable: true,
      },
      // breakpoints: {
      //   769: {
      //     carouselEffect: {
      //       sideSlides: 3,
      //     },
      //   },
      // },
    });

    $('.js-carousel-story .swiper-slide').on('click', function() {
      if ($(this).hasClass('swiper-slide-prev')) {
        swiperStory.slidePrev();
      } else if ($(this).hasClass('swiper-slide-next')) {
        swiperStory.slideNext();
      }
    });
  });

  // ==========================================================================
  // 商品情報カルーセル
  // ==========================================================================

  $(function () {
    const swipePproduct01 = new Swiper(".js-carousel-product01", {
      modules: [EffectCarousel],
      effect: 'carousel',
      carouselEffect: {
        opacityStep: 0.33,
        scaleStep: 0.5,
        sideSlides: 1,
      },
      grabCursor: true,
      loop: true,
      speed: 500,
      // loopAdditionalSlides: 1,
      slidesPerView: 'auto',
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 4,
      },
      navigation: {
        nextEl: ".p-product-carousel__next01",
        prevEl: ".p-product-carousel__prev01",
      },
      pagination: {
        el: ".p-product-carousel__pagination01",
        clickable: true,
      },
      // breakpoints: {
      //   769: {
      //     carouselEffect: {
      //       sideSlides: 3,
      //     },
      //   },
      // },
    });

    $('.js-carousel-product01 .swiper-slide').on('click', function() {
      if ($(this).hasClass('swiper-slide-prev')) {
        swipePproduct01.slidePrev();
      } else if ($(this).hasClass('swiper-slide-next')) {
        swipePproduct01.slideNext();
      }
    });

    const swipePproduct02 = new Swiper(".js-carousel-product02", {
      modules: [EffectCarousel],
      effect: 'carousel',
      carouselEffect: {
        opacityStep: 0.33,
        scaleStep: 0.5,
        sideSlides: 1,
      },
      grabCursor: true,
      loop: true,
      speed: 500,
      // loopAdditionalSlides: 1,
      slidesPerView: 'auto',
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 3,
      },
      navigation: {
        nextEl: ".p-product-carousel__next02",
        prevEl: ".p-product-carousel__prev02",
      },
      pagination: {
        el: ".p-product-carousel__pagination02",
        clickable: true,
      },
      // breakpoints: {
      //   769: {
      //     carouselEffect: {
      //       sideSlides: 3,
      //     },
      //   },
      // },
    });

    $('.js-carousel-product02 .swiper-slide').on('click', function() {
      if ($(this).hasClass('swiper-slide-prev')) {
        swipePproduct02.slidePrev();
      } else if ($(this).hasClass('swiper-slide-next')) {
        swipePproduct02.slideNext();
      }
    });
  });

  // ==========================================================================
  // はじめての方へアコーディオン
  // ==========================================================================

  const duration = 500;
  const easing = "easeOutQuart";
  $(function () {
    const $accordionLevel1 = $('.js-beginners-accordion-toggle');

    $accordionLevel1.on("click", function (event) {
      event.preventDefault();
      const $accordionLevel1Target = $(this);
      const $accordionLevel2 = $accordionLevel1Target.siblings(".js-beginners-accordion-body");
      const $accordionLevel3 = $accordionLevel1Target.children(".p-beginners-accordion__toggle-bg");
      const $accordionLevel4 = $accordionLevel2.children(".p-beginners-accordion__body-bg");

      if ($accordionLevel1Target.is(".-active")) {
        $accordionLevel1Target.removeClass("-active");
        $accordionLevel2.slideUp(duration, easing);
        // void $accordionLevel1Target.offsetWidth;
        $accordionLevel3.stop(true, true).fadeOut(500);
        $accordionLevel4.stop(true, true).fadeOut(500);
      } else {
        $accordionLevel1Target.addClass("-active");
        $accordionLevel2.slideDown(duration, easing);
        $accordionLevel3.stop(true, true).fadeIn(500);
        $accordionLevel4.stop(true, true).fadeIn(500);
      }
    });
  });

  $(function () {
    
    const accordionNextBtns = document.querySelectorAll(".js-beginners-accordion-next");

    // モーダルを表示するボタンをクリックしたとき
    accordionNextBtns.forEach((accordionNextBtn) => {
      accordionNextBtn.addEventListener("click", (event) => {
        event.preventDefault();
        // console.log($(this));
        // console.log(event);
        // var  = $(location).attr('hash');
        // console.log(event.target.href);
        const id = event.target.href.substr(event.target.href.indexOf('#'));
        // console.log(id);
        const $accordionLevel1Target = $(id).children().children(".js-beginners-accordion-toggle");
        // const $a = $('#' + 'id');
        // console.log($a);
        const $accordionLevel2 = $accordionLevel1Target.siblings(".js-beginners-accordion-body");
        const $accordionLevel3 = $accordionLevel1Target.children(".p-beginners-accordion__toggle-bg");
        const $accordionLevel4 = $accordionLevel2.children(".p-beginners-accordion__body-bg");
        // console.log($accordionLevel2);
        // $accordionLevel1Target.addClass("-active");
        $accordionLevel2.slideDown(duration, easing);

        $accordionLevel1Target.addClass("-active");
        $accordionLevel2.slideDown(duration, easing);
        $accordionLevel3.stop(true, true).fadeIn(500);
        $accordionLevel4.stop(true, true).fadeIn(500);

        // console.log(event.target.id);
        // console.log($(this).attr("id"));
        // console.log($(this).attr("href"));
        // console.log(event.attr("id"));
        // console.log(event.attr("href"));
        



        // scrollbarWidth = window.innerWidth - document.body.clientWidth;
        // $("body").css({ "padding-right": scrollbarWidth + "px" });
        // const modalIndex = accordionNextBtn.dataset.slideIndex;
        // swiperStory.slideTo(modalIndex, 0);
        // const target = document.querySelector(".js-modal");
        // bodyScrollLock.disableBodyScroll(target);
        // document.documentElement.style.cssText = "overflow: hidden;";
        // modal.classList.add("is-active");
      });
    });
  });


  // ==========================================================================
  // イベント検索アコーディオン
  // ==========================================================================

  $(function () {
    const $eventSearchContentToggle = $('.js-event-search-content-toggle');

    $eventSearchContentToggle.on("click", function (event) {
      event.preventDefault();
      const $eventSearchContentTarget = $(this);
      const $eventSearchContentBody = $eventSearchContentTarget.siblings(".js-event-search-content-body");

      if ($eventSearchContentTarget.is(".-active")) {
        $eventSearchContentTarget.removeClass("-active");
        $eventSearchContentBody.slideUp(duration, easing);
      } else {
        $eventSearchContentTarget.addClass("-active");
        $eventSearchContentBody.slideDown(duration, easing);
      }
    });
  });


  // ==========================================================================
  // カード検索　レンジ
  // ==========================================================================
  
  $(function () {
    if ($(".js-range-inkcost")[0]) {
      const rangeInkcost = document.querySelector('.js-range-inkcost');
      const rangeInkcostMinVal = 0;
      const rangeInkcostMaxVal = 10;

      noUiSlider.create(rangeInkcost, {
        start: [rangeInkcostMinVal, rangeInkcostMaxVal],
        connect: true,
        range: {
          'min': rangeInkcostMinVal,
          'max': rangeInkcostMaxVal
        },
        step: 1,
        tooltips: true,
        format: {
          from: function(value) {
            return parseInt(value);
          },
          to: function(value) {
            return parseInt(value);
          }
        }
      });

      const rangeInkcostMin = document.querySelector('.js-range-inkcost-min');
      const rangeInkcostMax = document.querySelector('.js-range-inkcost-max');

      rangeInkcost.noUiSlider.on('update', function (values, handle) {
        var values = rangeInkcost.noUiSlider.get();
        rangeInkcostMin.value = values[0];
        rangeInkcostMax.value = values[1];
        // rangeInkcostMin.value = rangeInkcost.value;

        if ( rangeInkcostMin.value > rangeInkcostMinVal || rangeInkcostMax.value < rangeInkcostMaxVal ){
          rangeInkcost.classList.add("-active");
        } else {
          rangeInkcost.classList.remove("-active");
        }
      });

      rangeInkcostMin.addEventListener('change', function() {
        rangeInkcost.noUiSlider.set([this.value, null]);
      });

      rangeInkcostMax.addEventListener('change', function() {
        rangeInkcost.noUiSlider.set([null, this.value]);
      });

      const rangeAttack = document.querySelector('.js-range-attack');
      const rangeAttackMinVal = 0;
      const rangeAttackMaxVal = 10;

      noUiSlider.create(rangeAttack, {
        start: [rangeAttackMinVal, rangeAttackMaxVal],
        connect: true,
        range: {
          'min': rangeAttackMinVal,
          'max': rangeAttackMaxVal
        },
        step: 1,
        tooltips: true,
        format: {
          from: function(value) {
            return parseInt(value);
          },
          to: function(value) {
            return parseInt(value);
          }
        }
      });

      const rangeAttackMin = document.querySelector('.js-range-attack-min');
      const rangeAttackMax = document.querySelector('.js-range-attack-max');

      rangeAttack.noUiSlider.on('update', function (values, handle) {
        var values = rangeAttack.noUiSlider.get();
        rangeAttackMin.value = values[0];
        rangeAttackMax.value = values[1];

        if ( rangeAttackMin.value > rangeAttackMinVal || rangeAttackMax.value < rangeAttackMaxVal ){
          rangeAttack.classList.add("-active");
        } else {
          rangeAttack.classList.remove("-active");
        }
      });

      rangeAttackMin.addEventListener('change', function() {
        rangeAttack.noUiSlider.set([this.value, null]);
      });

      rangeAttackMax.addEventListener('change', function() {
        rangeAttack.noUiSlider.set([null, this.value]);
      });

      const rangeWillpower = document.querySelector('.js-range-willpower');
      const rangeWillpowerMinVal = 0;
      const rangeWillpowerMaxVal = 10;

      noUiSlider.create(rangeWillpower, {
        start: [rangeWillpowerMinVal, rangeWillpowerMaxVal],
        connect: true,
        range: {
          'min': rangeWillpowerMinVal,
          'max': rangeWillpowerMaxVal
        },
        step: 1,
        tooltips: true,
        format: {
          from: function(value) {
            return parseInt(value);
          },
          to: function(value) {
            return parseInt(value);
          }
        }
      });

      const rangeWillpowerMin = document.querySelector('.js-range-willpower-min');
      const rangeWillpowerMax = document.querySelector('.js-range-willpower-max');

      rangeWillpower.noUiSlider.on('update', function (values, handle) {
        var values = rangeWillpower.noUiSlider.get();
        rangeWillpowerMin.value = values[0];
        rangeWillpowerMax.value = values[1];

        if ( rangeWillpowerMin.value > rangeWillpowerMinVal || rangeWillpowerMax.value < rangeWillpowerMaxVal ){
          rangeWillpower.classList.add("-active");
        } else {
          rangeWillpower.classList.remove("-active");
        }
      });

      rangeWillpowerMin.addEventListener('change', function() {
        rangeWillpower.noUiSlider.set([this.value, null]);
      });

      rangeWillpowerMax.addEventListener('change', function() {
        rangeWillpower.noUiSlider.set([null, this.value]);
      });

      const rangeRoa = document.querySelector('.js-range-roa');
      const rangeRoaMinVal = 0;
      const rangeRoaMaxVal = 5;

      noUiSlider.create(rangeRoa, {
        start: [rangeRoaMinVal, rangeRoaMaxVal],
        connect: true,
        range: {
          'min': rangeRoaMinVal,
          'max': rangeRoaMaxVal
        },
        step: 1,
        tooltips: true,
        format: {
          from: function(value) {
            return parseInt(value);
          },
          to: function(value) {
            return parseInt(value);
          }
        }
      });

      const rangeRoaMin = document.querySelector('.js-range-roa-min');
      const rangeRoaMax = document.querySelector('.js-range-roa-max');

      rangeRoa.noUiSlider.on('update', function (values, handle) {
        var values = rangeRoa.noUiSlider.get();
        rangeRoaMin.value = values[0];
        rangeRoaMax.value = values[1];

        if ( rangeRoaMin.value > rangeRoaMinVal || rangeRoaMax.value < rangeRoaMaxVal ){
          rangeRoa.classList.add("-active");
        } else {
          rangeRoa.classList.remove("-active");
        }
      });

      rangeRoaMin.addEventListener('change', function() {
        rangeRoa.noUiSlider.set([this.value, null]);
      });

      rangeRoaMax.addEventListener('change', function() {
        rangeRoa.noUiSlider.set([null, this.value]);
      });

      const rangeMovecost = document.querySelector('.js-range-movecost');
      const rangeMovecostMinVal = 0;
      const rangeMovecostMaxVal = 3;

      noUiSlider.create(rangeMovecost, {
        start: [rangeMovecostMinVal, rangeMovecostMaxVal],
        connect: true,
        range: {
          'min': rangeMovecostMinVal,
          'max': rangeMovecostMaxVal
        },
        step: 1,
        tooltips: true,
        format: {
          from: function(value) {
            return parseInt(value);
          },
          to: function(value) {
            return parseInt(value);
          }
        }
      });

      const rangeMovecostMin = document.querySelector('.js-range-movecost-min');
      const rangeMovecostMax = document.querySelector('.js-range-movecost-max');

      rangeMovecost.noUiSlider.on('update', function (values, handle) {
        var values = rangeMovecost.noUiSlider.get();
        rangeMovecostMin.value = values[0];
        rangeMovecostMax.value = values[1];

        if ( rangeMovecostMin.value > rangeMovecostMinVal || rangeMovecostMax.value < rangeMovecostMaxVal ){
          rangeMovecost.classList.add("-active");
        } else {
          rangeMovecost.classList.remove("-active");
        }
      });

      rangeMovecostMin.addEventListener('change', function() {
        rangeMovecost.noUiSlider.set([this.value, null]);
      });

      rangeMovecostMax.addEventListener('change', function() {
        rangeMovecost.noUiSlider.set([null, this.value]);
      });

      const resetButton = document.querySelector('.p-cardlist-search__button-list-reset');
      resetButton.addEventListener('click', function() {
        rangeInkcost.noUiSlider.reset();
        rangeAttack.noUiSlider.reset();
        rangeWillpower.noUiSlider.reset();
        rangeRoa.noUiSlider.reset();
        rangeMovecost.noUiSlider.reset();
      });
    }
  });




  // ==========================================================================
  // カード検索 詳細な条件を追加 アコーディオン
  // ==========================================================================

  $(function () {
    if ($(".js-cardlist-search-toggle-sp")[0]) {
      function getElementHeight(element) {
        const clone = element.cloneNode(true);
        clone.style.cssText = 'display:block; height:auto; visibility:hidden;';
        element.appendChild(clone);
        const clone_height = clone.clientHeight;
        element.removeChild(clone);
        return clone_height;
      }

      if ($(".js-cardlist-search-toggle")[0]) {
        const cardlistSearchToggle = document.querySelector('.js-cardlist-search-toggle');
        // const cardlistSearchBody = document.querySelector('.js-cardlist-search-body');
        const cardlistSearchBody = cardlistSearchToggle.previousElementSibling;
        let cardlistSearchBodyHeight = 0;

        cardlistSearchToggle.addEventListener("click", function(event) {
          event.preventDefault();

          if (cardlistSearchToggle.classList.contains("-active")) {
            // const bodyHeight = getElementHeight(cardlistSearchBody);
            cardlistSearchBody.style.height = `${cardlistSearchBodyHeight}px`;
            setTimeout(function () {
              cardlistSearchToggle.classList.remove("-active");
              cardlistSearchBody.style.height = "0";
            }, 100);
          } else {
            cardlistSearchToggle.classList.add("-active");
            cardlistSearchBodyHeight = getElementHeight(cardlistSearchBody);
            cardlistSearchBody.style.height = `${cardlistSearchBodyHeight}px`;
            setTimeout(function () {
              cardlistSearchBody.style.height = 'auto';
            }, 500);


            
          }
        });
      }

      const cardlistSearchToggleSP = document.querySelectorAll('.js-cardlist-search-toggle-sp');
      // let cardlistSearchBodySPHeight = 0;

      cardlistSearchToggleSP.forEach(function (accordion) {
        accordion.addEventListener("click", function(event) {
          event.preventDefault();

          const cardlistSearchToggleSPTarget = this;
          const cardlistSearchBodySP = cardlistSearchToggleSPTarget.nextElementSibling;

          if (cardlistSearchToggleSPTarget.classList.contains("-active")) {
            // cardlistSearchToggleSPTarget.classList.remove("-active");
            // cardlistSearchBodySP.style.height = "";
            const cardlistSearchBodySPHeight = getElementHeight(cardlistSearchBodySP);
            cardlistSearchBodySP.style.height = `${cardlistSearchBodySPHeight}px`;
            setTimeout(function () {
              cardlistSearchToggleSPTarget.classList.remove("-active");
              cardlistSearchBodySP.style.height = "0";
            }, 100);
          } else {
            cardlistSearchToggleSPTarget.classList.add("-active");
            const cardlistSearchBodySPHeight = getElementHeight(cardlistSearchBodySP);
            cardlistSearchBodySP.style.height = `${cardlistSearchBodySPHeight}px`;
            // setTimeout(function () {
            //   cardlistSearchBodySP.style.height = 'auto';
            // }, 500);
          }
        });
      });

      const cardlistSearchTogglePC = document.querySelectorAll('.js-cardlist-search-toggle-pc');
      // let cardlistSearchBodyPCHeight = 0;

      cardlistSearchTogglePC.forEach(function (accordion) {
        accordion.addEventListener("click", function(event) {
          event.preventDefault();

          const cardlistSearchTogglePCTarget = this;
          const cardlistSearchBodyPC = cardlistSearchTogglePCTarget.nextElementSibling;

          if (cardlistSearchTogglePCTarget.classList.contains("-active")) {
            // cardlistSearchTogglePCTarget.classList.remove("-active");
            // cardlistSearchBodyPC.style.height = "";
            cardlistSearchTogglePCTarget.children[0].innerHTML="条件を設定する"
            const cardlistSearchBodyPCHeight = getElementHeight(cardlistSearchBodyPC);
            cardlistSearchBodyPC.style.height = `${cardlistSearchBodyPCHeight}px`;
            setTimeout(function () {
              cardlistSearchTogglePCTarget.classList.remove("-active");
              cardlistSearchBodyPC.style.height = "0";
            }, 100);
          } else {
            cardlistSearchTogglePCTarget.classList.add("-active");
            cardlistSearchTogglePCTarget.children[0].innerHTML="閉じる"
            const cardlistSearchBodyPCHeight = getElementHeight(cardlistSearchBodyPC);
            cardlistSearchBodyPC.style.height = `${cardlistSearchBodyPCHeight}px`;
            // setTimeout(function () {
            //   cardlistSearchBodyPC.style.height = 'auto';
            // }, 500);
          }
        });
      });
    }
  });

  // ==========================================================================
  // カード選択　横幅
  // ==========================================================================

  $(function () {
    if ($(".js-deckbuilder-create-result-card")[0]) {
      let deckbuilderCreateResultCard = document.querySelector('.js-deckbuilder-create-result-card');
      let deckbuilderCreateResult = document.querySelector('.js-deckbuilder-create-result');
      deckbuilderCreateResultCardWidth = deckbuilderCreateResultCard.clientWidth;
      deckbuilderCreateResult.style.cssText = "max-width: " + deckbuilderCreateResultCardWidth + "px;"

      const onResize = () => {
        deckbuilderCreateResult.style.cssText = "";
        deckbuilderCreateResultCardWidth = deckbuilderCreateResultCard.clientWidth;
        deckbuilderCreateResult.style.cssText = "max-width: " + deckbuilderCreateResultCardWidth + "px;"
      };

      setWindowEvents({
        resize: onResize,
        scroll: null,
        load: null,
      });
    }
  });

  // ==========================================================================
  // デッキ詳細　スクロール
  // ==========================================================================

  $(function () {
    if ($(".js-deckbuilder-deck-button")[0]) {
      window.addEventListener("scroll", function () {
        const deckbuilderDeckButton = document.querySelector(".js-deckbuilder-deck-button");
        const deckbuilderDeckButtonParent = deckbuilderDeckButton.parentNode;
        const listLast = document.querySelector(".l-main__inner");
        const listBottom = listLast.getBoundingClientRect().bottom + window.pageYOffset - 59 - window.innerHeight;


        // console.log(listBottom);
        // console.log(window.scrollY);
  
        if (window.scrollY > listBottom) {
          deckbuilderDeckButtonParent.style.position = "initial";
          deckbuilderDeckButton.style.bottom = "82px";
        } else {
          deckbuilderDeckButtonParent.style.position = "";
          deckbuilderDeckButton.style.bottom = "";
        }
      });
    }
  });

  // ==========================================================================
  // カード選択　スクロール
  // ==========================================================================

  $(function () {
    if ($(".js-deckbuilder-create-deck-button")[0]) {
      window.addEventListener("scroll", function () {
        const deckbuilderCreateDeckButton = document.querySelector(".js-deckbuilder-create-deck-button");
        const deckbuilderCreateDeckButtonParent = deckbuilderCreateDeckButton.parentNode;
        const listLast = document.querySelector(".l-main__inner");
        const listBottom = listLast.getBoundingClientRect().bottom + window.pageYOffset - 65 - window.innerHeight;


        // console.log(listBottom);
        // console.log(window.scrollY);
  
        if (window.scrollY > listBottom) {
          deckbuilderCreateDeckButtonParent.style.position = "initial";
          deckbuilderCreateDeckButton.style.bottom = "80px";
        } else {
          deckbuilderCreateDeckButtonParent.style.position = "";
          deckbuilderCreateDeckButton.style.bottom = "";
        }
      });
    }
  });

  // ==========================================================================
  // カード検索　スクロール
  // ==========================================================================

  $(function () {
    if ($(".js-cardlist-search-button")[0]) {
      window.addEventListener("scroll", function () {
        const cardlistSearchButton = document.querySelector(".js-cardlist-search-button");
        const cardlistSearchButtonParent = cardlistSearchButton.parentNode;
        const listLast = document.querySelector(".l-main__inner");
        // const listBottom = listLast.getBoundingClientRect().bottom + window.pageYOffset - 65 - window.innerHeight;
        let listBottom;
        const mediaQuery = new window.starterkit.MediaQuery();
        let  isMediaUpLG = mediaQuery.matchMedia.get("lg").matches;
        const scrollPosition = window.scrollY;
        const cardlistResult = $('.p-cardlist-result');
        let cardlistResultOffset = cardlistResult.offset().top;
        const footer = $('.c-footer');
        // let windowHeight = $(this).height();
        let windowHeight = window.innerHeight;
        let footerOffset = footer.offset().top;

        if (scrollPosition >= cardlistResultOffset) {
          cardlistSearchButton.classList.add('-scrolled');
        } else {
          cardlistSearchButton.classList.remove('-scrolled');
        }

        if (scrollPosition + windowHeight >= footerOffset) {
          cardlistSearchButton.classList.add('-fadeout');
        } else {
          cardlistSearchButton.classList.remove('-fadeout');
        }

        // const updateButton = () => {
        //   if (isMediaUpLG) {
        //     listBottom = listLast.getBoundingClientRect().bottom + window.pageYOffset - 215 - window.innerHeight;
        //     if (window.scrollY > listBottom) {
        //       cardlistSearchButtonParent.style.position = "initial";
        //       cardlistSearchButton.style.bottom = "230px";
        //     } else {
        //       cardlistSearchButtonParent.style.position = "";
        //       cardlistSearchButton.style.bottom = "";
        //     }
        //   } else {
        //     listBottom = listLast.getBoundingClientRect().bottom + window.pageYOffset - 157 - window.innerHeight;
        //     if (window.scrollY > listBottom) {
        //       cardlistSearchButtonParent.style.position = "initial";
        //       cardlistSearchButton.style.bottom = "172px";

        //       if (scrollPosition + windowHeight >= footerOffset) {
        //         cardlistSearchButton.classList.add('-out');
        //       } else {
        //         cardlistSearchButton.classList.remove('-out');
        //       }
        //     } else {
        //       cardlistSearchButtonParent.style.position = "";
        //       cardlistSearchButton.style.bottom = "";
        //     }
        //   }
        // }

        const onResize = () => {
          // isMediaUpLG = mediaQuery.matchMedia.get("lg").matches;
          cardlistResultOffset = cardlistResult.offset().top;
          // windowHeight = $(this).height();
          windowHeight = window.innerHeight;
          footerOffset = footer.offset().top;
          // updateButton();
        };
  
        setWindowEvents({
          resize: onResize,
          scroll: null,
          load: null,
        });
      });
    }
  });

  // ==========================================================================
  // カード選択モーダル　スクロール
  // ==========================================================================

  // $(function () {
  //   if ($(".js-deckbuilder-create-modal-deck-button")[0]) {
  //     document.querySelector(".p-deckbuilder-create-modal__wrapper").addEventListener("scroll", function () {
  //       console.log("111");
  //       const deckbuilderCreateModalDeckButton = document.querySelector(".js-deckbuilder-create-modal-deck-button");
  //       const deckbuilderCreateModalDeckButtonParent = deckbuilderCreateModalDeckButton.parentNode;
  //       const listLast = document.querySelector(".p-deckbuilder-create-modal__wrapper");
  //       const listBottom = listLast.getBoundingClientRect().bottom + window.pageYOffset - 59 - window.innerHeight;


  //       console.log(listBottom);
  //       console.log(window.scrollY);
  
  //       if (window.scrollY > listBottom) {
  //         deckbuilderCreateModalDeckButtonParent.style.position = "initial";
  //         deckbuilderCreateModalDeckButton.style.bottom = "82px";
  //       } else {
  //         deckbuilderCreateModalDeckButtonParent.style.position = "";
  //         deckbuilderCreateModalDeckButton.style.bottom = "";
  //       }
  //     });
  //   }
  // });


  // ==========================================================================
  // カード選択　プレースホルダー
  // ==========================================================================

  $(function () {
    if ($(".js-deckbuilder-create-search")[0]) {
      const deckbuilderDeckButton = document.querySelector(".js-deckbuilder-create-search");
      const mediaQuery = new window.starterkit.MediaQuery();
      let isMediaUpXL = mediaQuery.matchMedia.get("xl").matches;

      if (!isMediaUpXL) {
        deckbuilderDeckButton.placeholder = "検索ワード";
      } else {
        deckbuilderDeckButton.placeholder = "検索ワードを入力";
      }

      const onResize = () => {
        isMediaUpXL = mediaQuery.matchMedia.get("xl").matches;
        if (!isMediaUpXL) {
          deckbuilderDeckButton.placeholder = "検索ワード";
        } else {
          deckbuilderDeckButton.placeholder = "検索ワードを入力";
        }
      };
  
      setWindowEvents({
        resize: onResize,
        scroll: null,
        load: null,
      });
    }
  });






  // ==========================================================================
  // カード検索 詳細な条件を追加 アコーディオン
  // ==========================================================================

  $(function () {
    if ($(".js-deckbuilder-deck-status-toggle")[0]) {
      function getElementHeight(element) {
        const clone = element.cloneNode(true);
        clone.style.cssText = 'display:block; height:auto; visibility:hidden;';
        element.appendChild(clone);
        const clone_height = clone.clientHeight;
        element.removeChild(clone);
        return clone_height;
      }
      
      const deckbuilderDeckStatusToggle = document.querySelectorAll('.js-deckbuilder-deck-status-toggle');
      // let cardlistSearchBodySPHeight = 0;

      deckbuilderDeckStatusToggle.forEach(function (accordion) {
        accordion.addEventListener("click", function(event) {
          event.preventDefault();

          const deckbuilderDeckStatusToggleTarget = this;
          const deckbuilderDeckStatusBody = deckbuilderDeckStatusToggleTarget.nextElementSibling;

          if (deckbuilderDeckStatusToggleTarget.classList.contains("-active")) {
            // deckbuilderDeckStatusToggleTarget.classList.remove("-active");
            // deckbuilderDeckStatusBody.style.height = "";
            const deckbuilderDeckStatusBodyHeight = getElementHeight(deckbuilderDeckStatusBody);
            deckbuilderDeckStatusBody.style.height = `${deckbuilderDeckStatusBodyHeight}px`;
            setTimeout(function () {
              deckbuilderDeckStatusToggleTarget.classList.remove("-active");
              deckbuilderDeckStatusBody.style.height = "0";
            }, 100);
          } else {
            deckbuilderDeckStatusToggleTarget.classList.add("-active");
            const deckbuilderDeckStatusBodyHeight = getElementHeight(deckbuilderDeckStatusBody);
            deckbuilderDeckStatusBody.style.height = `${deckbuilderDeckStatusBodyHeight}px`;
            // setTimeout(function () {
            //   deckbuilderDeckStatusBody.style.height = 'auto';
            // }, 500);
          }
        });
      });
    }
  });



  // ==========================================================================
  // デッキ詳細 影の制御
  // ==========================================================================

  // $(function () {
  //   if ($(".js-deckbuilder-deck-card")[0]) {
  //     const deckbuilderDeckcard = document.querySelector('.js-deckbuilder-deck-card');
  //     const deckbuilderDeckcardSimpleBar = new SimpleBar(document.querySelector('.js-deckbuilder-deck-card'));
  //     const deckbuilderDeckcardSimpleBarScrollElement = deckbuilderDeckcardSimpleBar.getScrollElement();
  //     // const deckbuilderDeckcardSimpleBarScrollbarElement = deckbuilderDeckcardSimpleBar.getScrollbarElement();
  //     // deckbuilderDeckcardSimpleBarScrollbarElement.style.opacity = '1';

  //     // deckbuilderDeckcardSimpleBarScrollElement.addEventListener('mouseleave', function () {
  //     //   deckbuilderDeckcardSimpleBarScrollbarElement.style.opacity = '1';
  //     // });

  //     const deckbuilderDeckcardSimpleBarScrollElementClientHeight = deckbuilderDeckcardSimpleBarScrollElement.clientHeight;
  //     const deckbuilderDeckcardSimpleBarScrollElementScrollHeight = deckbuilderDeckcardSimpleBarScrollElement.scrollHeight;
  //     const hasScrollbar = deckbuilderDeckcardSimpleBarScrollElementScrollHeight > deckbuilderDeckcardSimpleBarScrollElementClientHeight;

  //     if (!hasScrollbar) {
  //       deckbuilderDeckcard.classList.add("-bottom");
  //     }

  //     deckbuilderDeckcardSimpleBarScrollElement.addEventListener('scroll', function () {
  //       const deckbuilderDeckcardSimpleBarScrollElementScrollTop = deckbuilderDeckcardSimpleBarScrollElement.scrollTop;

  //       if (deckbuilderDeckcardSimpleBarScrollElementScrollHeight - deckbuilderDeckcardSimpleBarScrollElementScrollTop - deckbuilderDeckcardSimpleBarScrollElementClientHeight < 1) {
  //         deckbuilderDeckcard.classList.add("-bottom");
  //       } else {
  //         deckbuilderDeckcard.classList.remove("-bottom");
  //       }
  //     });
  //   }
  // });


  // ==========================================================================
  // カード選択 カード絞込ボタン　デッキ詳細　追従
  // ==========================================================================

  $(function () {
    if ($(".p-deckbuilder-create__bottom")[0]) {
      window.addEventListener('scroll', function() {
        const container = document.querySelector('.p-deckbuilder-create__bottom');
        const result = document.querySelector('.p-deckbuilder-create-result__inner');
        const parentRect = container.getBoundingClientRect();
        const sidebar = document.querySelector('.p-deckbuilder-create-deck__wrapper');
        // const sidebarInner = document.querySelector('.p-deckbuilder-create-deck__inner');
        const deckbuilderCreateSearchButton = document.querySelector('.js-deckbuilder-create-search-button');
        const listBottom = parentRect.bottom + window.pageYOffset - window.innerHeight;
        // const listBottom2 = document.querySelector('.p-deckbuilder-create').getBoundingClientRect().bottom - parentRect.bottom;
        
        if (result.clientHeight < 1145) {
          sidebar.style.position = '';
          sidebar.style.top = '';
          sidebar.style.right = '';
          sidebar.style.bottom = '';
          sidebar.style.left = '';
          deckbuilderCreateSearchButton.style.opacity = '0';


        // } else if (sidebarInner.classList.contains('-remove') && window.scrollY - 60 > listBottom) {
        //   console.log("111");
        //   sidebar.style.position = 'absolute';
        //   sidebar.style.top = '';
        //   sidebar.style.right = '0';
        //   sidebar.style.bottom = '0';
        //   sidebar.style.left = '';

        } else if (window.scrollY + 90 > listBottom) {
          // console.log("222");
          sidebar.style.position = 'absolute';
          sidebar.style.top = '';
          sidebar.style.right = '0';
          sidebar.style.bottom = '0';
          sidebar.style.left = '';
        } else if (parentRect.top - 27 <= 0) {
          sidebar.style.position = 'fixed';
          sidebar.style.top = '81px';
          sidebar.style.right = '';
          sidebar.style.bottom = '';
          sidebar.style.left = parentRect.right - '430px';
          deckbuilderCreateSearchButton.style.opacity = '1';
        } else {
          sidebar.style.position = '';
          sidebar.style.top = '';
          sidebar.style.right = '';
          sidebar.style.bottom = '';
          sidebar.style.left = '';
          deckbuilderCreateSearchButton.style.opacity = '0';
        }
      });
    }
  });

  




  $(function () {
    // 親要素と子要素を querySelectorAll で取得
    const parents = document.querySelectorAll('.p-deckbuilder-create-result__card-list');
    // const children = document.querySelectorAll('.p-deckbuilder-create-result__card-list-select');

    // 親要素ごとに処理を行う
    parents.forEach((parent, index) => {
      const child = parent.querySelector('.p-deckbuilder-create-result__card-list-select'); // 親要素内の子要素を取得

      // 子要素に hover したときに親要素を無効化
      child.addEventListener('mouseenter', function(event) {
        // event.stopPropagation();
        // child.style.pointerEvents = 'auto';
        // parent.style.pointerEvents = 'none';
        parent.classList.add("-child");
      });

      // 子要素から hover が外れたときに親要素を有効化
      child.addEventListener('mouseleave', function() {
        // parent.style.pointerEvents = 'auto';
        parent.classList.remove("-child");
      });
    });
  });

  $(function () {
    // 親要素と子要素を querySelectorAll で取得
    const parents = document.querySelectorAll('.p-deckbuilder-create-deck__card-list');
    // const children = document.querySelectorAll('.p-deckbuilder-create-result__card-list-select');

    // 親要素ごとに処理を行う
    parents.forEach((parent, index) => {
      const child = parent.querySelector('.p-deckbuilder-create-deck__card-list-select'); // 親要素内の子要素を取得

      // 子要素に hover したときに親要素を無効化
      child.addEventListener('mouseenter', function(event) {
        // event.stopPropagation();
        // child.style.pointerEvents = 'auto';
        // parent.style.pointerEvents = 'none';
        parent.classList.add("-child");
      });

      // 子要素から hover が外れたときに親要素を有効化
      child.addEventListener('mouseleave', function() {
        // parent.style.pointerEvents = 'auto';
        parent.classList.remove("-child");
      });
    });
  });



  // ==========================================================================
  // ルール・Q&A アコーディオン
  // ==========================================================================

  $(function () {
    if ($(".js-rulefaq-card-toggle")[0]) {
      function getElementHeight(element) {
        const clone = element.cloneNode(true);
        clone.style.cssText = 'display:block; height:auto; visibility:hidden;';
        element.appendChild(clone);
        const clone_height = clone.clientHeight;
        element.removeChild(clone);
        return clone_height;
      }
      
      const deckbuilderDeckStatusToggle = document.querySelectorAll('.js-rulefaq-card-toggle');
      // let cardlistSearchBodySPHeight = 0;

      deckbuilderDeckStatusToggle.forEach(function (accordion) {
        accordion.addEventListener("click", function(event) {
          event.preventDefault();

          const deckbuilderDeckStatusToggleTarget = this;
          const deckbuilderDeckStatusBody = deckbuilderDeckStatusToggleTarget.nextElementSibling;

          if (deckbuilderDeckStatusToggleTarget.classList.contains("-active")) {
            // deckbuilderDeckStatusToggleTarget.classList.remove("-active");
            // deckbuilderDeckStatusBody.style.height = "";
            const deckbuilderDeckStatusBodyHeight = getElementHeight(deckbuilderDeckStatusBody);
            deckbuilderDeckStatusBody.style.height = `${deckbuilderDeckStatusBodyHeight}px`;
            setTimeout(function () {
              deckbuilderDeckStatusToggleTarget.classList.remove("-active");
              deckbuilderDeckStatusBody.style.height = "0";
            }, 100);
          } else {
            deckbuilderDeckStatusToggleTarget.classList.add("-active");
            const deckbuilderDeckStatusBodyHeight = getElementHeight(deckbuilderDeckStatusBody);
            deckbuilderDeckStatusBody.style.height = `${deckbuilderDeckStatusBodyHeight}px`;
            // setTimeout(function () {
            //   deckbuilderDeckStatusBody.style.height = 'auto';
            // }, 500);
          }
        });
      });
    }
  });

  // ==========================================================================
  // よくある質問 チェックボックス
  // ==========================================================================

  $(function () {
      allCheckbox();

      function allCheckbox() {
        // 「すべて」にチェックが付いている場合、「すべて」を無効化
        if ($('#form-product-all').prop('checked')) {
            $('#form-product-all').prop('disabled', true); // 「すべて」を無効化
        } else {
            $('#form-product-all').prop('disabled', false); // 「すべて」の無効化を解除
        }
      }

      // 「すべて」が変更されたとき
      $('#form-product-all').change(function() {
        if ($(this).prop('checked')) {
          $('.p-rulefaq__qa-product-list-item-checkbox').not('#form-product-all').prop('checked', false);
          $('#form-product-all').prop('disabled', true);
        } else {
          $('#form-product-all').prop('disabled', false);
        }
      });
    
      //「すべて」以外が変更された場合
      $('.p-rulefaq__qa-product-list-item-checkbox').not('#form-product-all').change(function() {
        if ($('.p-rulefaq__qa-product-list-item-checkbox:checked').not('#form-product-all').length > 0) {
          $('#form-product-all').prop('checked', false);
          $('#form-product-all').prop('disabled', false);
        }
        if ($('.p-rulefaq__qa-product-list-item-checkbox:checked').length === 0) {
          $('#form-product-all').prop('checked', true);
          $('#form-product-all').prop('disabled', true);
        }
      });
    });





  // ==========================================================================
  // イベント loading="lazy" があれば削除
  // ==========================================================================
  $(function () {
    if ($(".p-event-detail")[0]) {
      $('.p-event-detail img').each(function() {
          if ($(this).attr('loading') === 'lazy') {
              $(this).removeAttr('loading');
          }
      });
    }
  });
  


  // ==========================================================================
  // イベント 画像のサイズ調整
  // ==========================================================================

  $(function () {
    if ($(".p-event-detail")[0]) {
      const updateImageSize = () => {
        $('.p-event-detail .wp-block-image:not(.-thumb)').each(function() {
          const img = new Image();
          const $img = $(this).find('img');
          img.src = $img.attr('src');
          const $figure = $img.parent();
          const originalWidth = img.width;
          const floorOriginalWidth = Math.floor(originalWidth / 2);
          $figure.css('max-width', `${floorOriginalWidth}px`);
          $figure.addClass('-active');              
        });
      };
  
      updateImageSize();

      const onResize = () => {
        updateImageSize();
      };
  
      setWindowEvents({
        resize: onResize,
        scroll: null,
        load: null,
      });
    }

    // if ($(".p-event-detail")[0]) {
    //   const mediaQuery = new window.starterkit.MediaQuery();
    //   let isMediaUpLG = mediaQuery.matchMedia.get("lg").matches;
  
    //   const updateImageSize = (reset = false) => {
    //     $('.p-event-detail .wp-block-image:not(.-thumb)').each(function() {
    //       const $img = $(this).find('img');
    //       const $figure = $img.parent();

    //       if (reset) {
    //         $figure.css('width', ``);
    //       } else {
    //         const originalWidth = $img[0].naturalWidth;
    //         const floorOriginalWidth = Math.floor(originalWidth / 2);
    //         $figure.css('width', `${floorOriginalWidth}px`);
    //       }
    //     });
    //   };
  
    //   updateImageSize(!isMediaUpLG);

    //   const onResize = () => {
    //     isMediaUpLG = mediaQuery.matchMedia.get("lg").matches;
    //     updateImageSize(!isMediaUpLG);
    //   };
  
    //   setWindowEvents({
    //     resize: onResize,
    //     scroll: null,
    //     load: null,
    //   });
    // }
  });



  // ==========================================================================
  // イベント検索 パラメータ追加
  // ==========================================================================

  $(function () {
    if ($(".p-event-search")[0]) {
      $.datepicker._gotoToday = function(id) {
        var target = $(id);
        var inst = this._getInst(target[0]);
        var date = new Date();
        this._setDate(inst,date);
        this._hideDatepicker();
      }

      var setCalsClearFromButton = function(year,month,elem){
        var afterShow = function(){
          var d = new $.Deferred();
          var cnt = 0;
          setTimeout(function(){
              if(elem.dpDiv[0].style.display === "block"){
                  d.resolve();
              }
              if(cnt >= 500){
                  d.reject("datepicker show timeout");
              }
              cnt++;
          },10);
          return d.promise();
        }();

        afterShow.done(function(){
          $('.ui-datepicker').css('z-index', 2000);
          var buttonPane = $( elem ).datepicker( "widget" ).find( ".ui-datepicker-buttonpane" );
          var btn = $('<button class="ui-datepicker-clear ui-state-default ui-priority-primary ui-corner-all" type="button">削除</button>');
          btn.off("click").on("click", function () {
            $.datepicker._clearDate( elem.input[0] );
            var today = new Date();
            var todayFormatted = $.datepicker.formatDate('yy/mm/dd', today); 
            elem.input.datepicker('setDate', todayFormatted);
            // elem.input.datepicker('hide');
          });
          btn.appendTo(buttonPane);
        });
      }

      var setCalsClearToButton = function(year,month,elem){
        var afterShow = function(){
          var d = new $.Deferred();
          var cnt = 0;
          setTimeout(function(){
              if(elem.dpDiv[0].style.display === "block"){
                  d.resolve();
              }
              if(cnt >= 500){
                  d.reject("datepicker show timeout");
              }
              cnt++;
          },10);
          return d.promise();
        }();

        afterShow.done(function(){
          $('.ui-datepicker').css('z-index', 2000);
          var buttonPane = $( elem ).datepicker( "widget" ).find( ".ui-datepicker-buttonpane" );
          var btn = $('<button class="ui-datepicker-clear ui-state-default ui-priority-primary ui-corner-all" type="button">削除</button>');
          btn.off("click").on("click", function () {
            $.datepicker._clearDate( elem.input[0] );
          });
          btn.appendTo(buttonPane);
        });
      }

      $( ".js-datepicker-from" ).datepicker({
        beforeShowDay: function(date) {
          if (date.getDay() === 0) {
            return [true, "ui-datepicker-calendar-sunday", ""];
          }
          else if (date.getDay() === 6) {
            return [true, "ui-datepicker-calendar-saturday", ""];
          }
          else {
            return [true, "ui-datepicker-calendar-weekday", ""];
          }
        },
        beforeShow: function(inst, elem) {
          setCalsClearFromButton(null, null, elem);
        },
        onChangeMonthYear:setCalsClearFromButton,
        showButtonPanel: true
      });

      $( ".js-datepicker-to" ).datepicker({
        beforeShowDay: function(date) {
          if (date.getDay() === 0) {
            return [true, "ui-datepicker-calendar-sunday", ""];
          }
          else if (date.getDay() === 6) {
            return [true, "ui-datepicker-calendar-saturday", ""];
          }
          else {
            return [true, "ui-datepicker-calendar-weekday", ""];
          }
        },
        beforeShow: function(inst, elem) {
          setCalsClearToButton(null, null, elem);
        },
        onChangeMonthYear:setCalsClearToButton,
        showButtonPanel: true
      });

      $.datepicker.regional['ja'] = {
        closeText: "閉じる",
        prevText: "&#x3C;前",
        nextText: "次&#x3E;",
        currentText: "今日",
        monthNames: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
        monthNamesShort: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
        dayNames: ["日曜日", "月曜日", "火曜日", "水曜日", "木曜日", "金曜日", "土曜日"],
        dayNamesShort: ["日", "月", "火", "水", "木", "金", "土"],
        dayNamesMin: ["日", "月", "火", "水", "木", "金", "土"],
        weekHeader: "週",
        dateFormat: "yy/mm/dd",
        firstDay: 0,
        isRTL: false,
        showMonthAfterYear: true,
        yearSuffix: "年",
        minDate: 0,
      };
      // 日本語のロケールを適用
      $.datepicker.setDefaults($.datepicker.regional['ja']);
    }
  });

  $(function () {
    function resetForm() {
      $('.js-form-event').prop('selectedIndex', 0);
      $('.js-form-word').val('');
      $('.js-form-prefecture').prop('selectedIndex', 0);
      const today = new Date();
      const todayFormat = $.datepicker.formatDate('yy/mm/dd', today);
      $('.js-datepicker-from').datepicker('setDate', todayFormat);
      today.setMonth(today.getMonth() + 1);
      const oneMonthFormat = $.datepicker.formatDate('yy/mm/dd', today);
      $('.js-datepicker-to').datepicker('setDate', oneMonthFormat);
    }

    $('.js-button-reset').on('click', function (e) {
      e.preventDefault();
      resetForm();
    });
  });

  // ルール・Q&Aトップ 2つ目のタブによる遷移
  $(function () {
    const params = new URLSearchParams(window.location.search);
    const tab = params.get("tab");

    if (tab === "2") {
      document.querySelectorAll(".js-tab-button").forEach(el => {
        el.classList.remove("-active");
      });

      document.querySelectorAll(".js-tab-panel").forEach(el => {
        el.classList.remove("-active");
        el.style.visibility = "hidden";
        el.style.display = "none";
      });

      const secondTabButton = document.querySelectorAll(".js-tab-button")[1];
      const secondTabPanel = document.querySelectorAll(".js-tab-panel")[1];
      if (secondTabButton) {
        secondTabButton.classList.add("-active");
        secondTabPanel.style.visibility = "visible";
        secondTabPanel.style.display = "block";

        setTimeout(() => {
          secondTabPanel.classList.add("-active");
        }, 20);

        const newUrl = location.pathname + location.hash;
        history.replaceState(null, "", newUrl);
      }
    }
  });

  // バナーアニメーション
  $(window).on("load", function () {
    const $bnr = $('.js-top-bnr');
    if (!$bnr.length) return;
    const $container = $bnr.parent();
    const $hero = $('.p-top-hero');
    let moved = false;
    let shown = false;
    let lastWidth = window.innerWidth;

    function getBnrHeight($bnr) {
      const $clone = $bnr.clone()
        .css({
          display: 'block',
          opacity: '0',
          position: 'absolute',
          visibility: 'hidden',
        })
        .appendTo('body');

      const h = $clone.outerHeight();
      $clone.remove();
      return h;
    }

    function getPositions() {
      const scrollY = window.scrollY;
      const windowH = window.innerHeight;
      const windowW = window.innerWidth;
      const heroBottom = $hero.offset().top + $hero.outerHeight();
      const stopPoint = heroBottom + 40 * (windowW / 375);
      const bnrH = getBnrHeight($bnr);
      const bnrBottomY = scrollY + windowH - 20 * (windowW / 375);
      return { scrollY, windowH, heroBottom, stopPoint, bnrH, bnrBottomY };
    }

    function calcAbsBottom(stopPoint) {
      const containerTop = $container.offset().top;
      return $container.height() - (stopPoint + $bnr.outerHeight() - containerTop);
    }

    function updateBnrPosition() {
      const { bnrBottomY, stopPoint, bnrH } = getPositions();

      if (!moved && bnrBottomY >= stopPoint + bnrH) {
        const absBottom = calcAbsBottom(stopPoint);
        $bnr.css({ position: 'absolute', bottom: absBottom + 'px' });
        moved = true;

        if (!shown) {
          $bnr.fadeIn(600);
          $bnr.addClass("-active");
          shown = true;
        }
      } else if (!moved) {
        if (!shown) {
          $bnr.fadeIn(600);
          $bnr.addClass("-active");
          shown = true;
        }

        $bnr.css({
          position: 'fixed',
          bottom: 20 * (window.innerWidth / 375) + 'px'
        });
      }
    }

    function handleResize() {
      const currentWidth = window.innerWidth;

      if (currentWidth !== lastWidth) {
        lastWidth = currentWidth;
        $bnr.css({ position: '', bottom: '' });
        moved = false;
        updateBnrPosition();
      }
    }

    updateBnrPosition();
    $(window).on('scroll', updateBnrPosition);
    $(window).on('resize', handleResize);
  });

})();